import breakpoints from '../common/breakpoints';
import fontSizes from '../common/font-sizes';
import radii from '../common/radii';
import space from '../common/space';
import colors from './colors';
import textVariants from './variants/text';

const LightTheme = {
  radii,
  space,
  colors,
  fontSizes,
  breakpoints,
  textVariants,
};

export type Theme = typeof LightTheme;

export default LightTheme;
